import React from 'react';
import { MinervaLogo } from './MinervaLogo';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, MapPin, FileText, LayoutGrid } from 'lucide-react';
interface TopBarProps {
  onBack?: () => void;
  onSkip?: () => void;
  onOpenMap?: () => void;
  onOpenStoryboard?: () => void;
  onOpenVisualStoryboard?: () => void;
}
export function TopBar({
  onBack,
  onSkip,
  onOpenMap,
  onOpenStoryboard,
  onOpenVisualStoryboard
}: TopBarProps) {
  return <motion.div initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5
  }} className="absolute top-0 left-0 right-0 px-5 py-4 flex justify-between items-center z-30" data-id="element-271">
      <div className="flex items-center gap-3" data-id="element-272">
        {onBack && <button onClick={onBack} className="flex items-center justify-center w-8 h-8 rounded-full bg-white/80 border border-slate-200 text-slate-600 backdrop-blur-md shadow-sm hover:bg-white transition-colors shrink-0" aria-label="Go back" data-id="element-273">
            <ChevronLeft size={18} data-id="element-274" />
          </button>}
        <MinervaLogo className="shrink-0" data-id="element-275" />
      </div>

      <div className="flex items-center gap-2" data-id="element-276">
        {onOpenStoryboard && <button onClick={onOpenStoryboard} className="flex items-center justify-center w-8 h-8 rounded-full bg-white/80 border border-slate-200 text-slate-600 backdrop-blur-md shadow-sm hover:bg-white transition-colors shrink-0" aria-label="View Brief" data-id="element-277">
            <FileText size={16} data-id="element-278" />
          </button>}
        {onOpenVisualStoryboard && <button onClick={onOpenVisualStoryboard} className="flex items-center justify-center w-8 h-8 rounded-full bg-white/80 border border-slate-200 text-slate-600 backdrop-blur-md shadow-sm hover:bg-white transition-colors shrink-0" aria-label="View Visual Storyboard" data-id="element-279">
            <LayoutGrid size={16} data-id="element-280" />
          </button>}
        {onOpenMap && <button onClick={onOpenMap} className="flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 rounded-full bg-white/80 border border-slate-200 backdrop-blur-md shadow-sm hover:bg-white transition-colors shrink-0" data-id="element-281">
            <MapPin size={12} className="text-minerva-blue" data-id="element-282" />
            <span className="text-[10px] font-semibold text-slate-600 tracking-widest uppercase hidden sm:inline-block" data-id="element-283">
              Booth #1762
            </span>
            <span className="text-[10px] font-semibold text-slate-600 tracking-widest uppercase sm:hidden" data-id="element-284">
              Booth
            </span>
          </button>}
        {onSkip && <button onClick={onSkip} className="flex items-center gap-1 px-2.5 sm:px-3 py-1.5 rounded-full bg-white/80 border border-slate-200 text-slate-600 backdrop-blur-md shadow-sm hover:bg-white transition-colors text-[10px] font-semibold tracking-widest uppercase shrink-0" data-id="element-285">
            Skip
            <ChevronRight size={14} data-id="element-286" />
          </button>}
      </div>
    </motion.div>;
}